import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PerfTrendComponent} from './perf-trend.component';
import {HighchartsChartModule} from "highcharts-angular";
import {AlertBannerModule} from "../../lib/alert-banner";


@NgModule({
  declarations: [PerfTrendComponent],
  imports: [
    CommonModule,
    HighchartsChartModule,
    AlertBannerModule.forRoot(),
  ],
  exports: [PerfTrendComponent]
})
export class PerfTrendModule {
}
